import { module } from 'angular';

import { default as memoServiceName, MemoService } from './memo.service';
import { default as memoPopupName, MemoPopup } from './popup/memo-popup.component';

export default module('contact.agent.core.channel-digit.mail.memo', [])
  .service(memoServiceName, MemoService)
  .component(memoPopupName, new MemoPopup()).name;
